export const base_url ="https://q73ion9zv2.execute-api.us-east-2.amazonaws.com/dev/api/";
export const wss_url = "wss://xyb4ieph9f.execute-api.us-east-2.amazonaws.com/production/"
// export const base_url = process.env.REACT_APP_BASE_URL;